function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useRef, useState, useEffect } from 'react';
import c from 'classnames';
var MagicLine = function MagicLine(_ref) {
  var _ref$activeClassName = _ref.activeClassName,
    activeClassName = _ref$activeClassName === void 0 ? 'Menu__item--active' : _ref$activeClassName,
    children = _ref.children;
  var magicLineParentRef = useRef(null);
  var magicLineRef = useRef(null);
  var currentActiveItem = useRef(null);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    loaded = _useState2[0],
    setLoaded = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    activeItemInNavigation = _useState4[0],
    _setActiveItemInNavigation = _useState4[1];
  var setActiveItemInNavigation = function setActiveItemInNavigation(value) {
    if (value !== activeItemInNavigation) {
      _setActiveItemInNavigation(value);
    }
  };
  var MagicLineRefClasses = c('MagicLine__magic_line', {
    'MagicLine__magic_line--visible': activeItemInNavigation && loaded
  });
  var alignMagicLine = function alignMagicLine() {
    if (magicLineRef.current && currentActiveItem.current) {
      var left = currentActiveItem.current.getBoundingClientRect().left - magicLineParentRef.current.getBoundingClientRect().left;
      var right = magicLineParentRef.current.getBoundingClientRect().width - left - currentActiveItem.current.getBoundingClientRect().width;
      magicLineRef.current.style.left = "".concat(left, "px");
      magicLineRef.current.style.right = "".concat(right, "px");
      setLoaded(true);
    }
  };
  var hoverMagicLine = function hoverMagicLine(e) {
    currentActiveItem.current = e.target;
    _setActiveItemInNavigation(true);
    alignMagicLine();
  };
  var setInitialMagicLine = function setInitialMagicLine() {
    currentActiveItem.current = document.getElementsByClassName(activeClassName)[0];
    if (!currentActiveItem.current) {
      _setActiveItemInNavigation(false);
    }
    alignMagicLine();
  };
  useEffect(function () {
    var initialize = function initialize() {
      setInitialMagicLine();
    };
    var handleResize = function handleResize() {
      alignMagicLine();
    };
    document.fonts.ready.then(initialize);
    window.addEventListener('load', initialize);
    window.addEventListener('resize', handleResize);
    return function () {
      window.removeEventListener('load', initialize);
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    ref: magicLineParentRef,
    className: "MagicLine"
  }, /*#__PURE__*/React.createElement("div", {
    ref: magicLineRef,
    className: MagicLineRefClasses
  }), children(setInitialMagicLine, hoverMagicLine, setActiveItemInNavigation));
};
export default MagicLine;